import React, { useState, useEffect } from "react";
import AuthRouter from './authRouter';
import UserRouter from './userRouter';
import { Cookies } from "react-cookie";
import { useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";

const IndexRouter = () => {
    const cookies = new Cookies();
    const [userRole, setUserRole] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        // You can add any logic that needs to run when userRole changes
    }, [userRole]);

    const checkFunction = () => {
        if (cookies.get('PDATokenStage')) {
            let data = cookies.get('PDATokenStage');
            if (data && data !== "") {
				console.log("in checkFunction, found cookie PDATokenStage");
                return true;
            } else {
				console.log("in checkFunction, found blank cookie PDATokenStage");
                return false;
            }
        } else {
			console.log("in checkFunction, did not find cookie PDATokenStage");
            return false;
        }
    };

    const updateUser = (data) => {
        setUserRole(data);
    };

    const logoutUser = async () => {
        setUserRole("");
        cookies.remove('PDATokenStage', { path: '/' });
        cookies.remove('PDAUserStage', { path: '/' });
        navigate('/');
        toast.success("Logged out successfully.");
    };

    return (
        <>
            {(checkFunction()) ? (
                <UserRouter logoutUser={logoutUser} />
            ) : (
                <AuthRouter updatedUser={updateUser} />
            )}
        </>
    );
};

export default IndexRouter;